import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { fetchBillsToPay, resetBillsToPay } from '../../../actions/billsToPay';
import { fetchCurrentUser } from '../../../actions/loginAction';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from '../../../components/Grid/GridContainer.jsx';
import Button from '../../../components/CustomButtons/Button.jsx';
import Grid from '@material-ui/core/Grid';
import RefreshIcon from '@material-ui/icons/Refresh';

import BillsToPayListTable from './BillsToPayListTable';

const style = {};
class BillsToPayListPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      billsToPay: null,
    };
  }

  componentDidMount() {
    this.props.fetchBillsToPay();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.billsToPay &&
      prevProps.billsToPay !== this.props.billsToPay
    ) {
      this.setState(
        {
          notificationMessage: 'Dados atualizados',
          billsToPay: this.props.billsToPay,
        },
        () => this.showNotification('primary')
      );
    }
    if (
      this.props.billsToPayError &&
      prevProps.billsToPayError != this.props.billsToPayError
    ) {
      this.setState({ notificationMessage: this.props.billsToPayError }, () =>
        this.showNotification('danger')
      );
    }
  }

  showNotification(place) {
    if (!this.state[place]) {
      var timeToFade = 4000;
      var x = [];
      x[place] = true;
      this.setState(x, () => {
        setTimeout(
          function() {
            x[place] = false;
            if (place === 'br') {
              x['createOrEditUserSuccessMessage'] = '';
            } else if (place === 'bl') {
              x['deleteUserSuccessMessage'] = '';
            }
            this.setState(x);
          }.bind(this),
          timeToFade
        );
      });
    }
  }

  render() {
    return (
      <div>
        <GridContainer justify="flex-end">
          <Grid item>
            <Button
              onClick={() => this.props.fetchBillsToPay()}
              color="primary"
              size="sm"
            >
              <RefreshIcon /> Atualizar
            </Button>
          </Grid>
        </GridContainer>
        <BillsToPayListTable
          tableData={this.state.billsToPay}
          {...this.props}
        />
      </div>
    );
  }
}

BillsToPayListPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    authenticatedUser: state.loginReducer.authenticatedUser,
    billsToPay: state.billsToPayReducer.bills_to_pay,
    billsToPayError: state.billsToPayReducer.bills_to_pay_error,
  };
}

export default compose(
  withStyles(style),
  connect(mapStateToProps, {
    fetchCurrentUser,
    fetchBillsToPay,
    resetBillsToPay,
  })
)(withRouter(BillsToPayListPage));
